import React from 'react'
import PageLayout from '../components/templates/page-layout/page-layout'
import Ganadoras from '../components/organisms/Winners/Winner';

const GanadorasPage = () => {
  return (
    <div className="f-roulette-winner-page">
      <PageLayout>
        <Ganadoras />
      </PageLayout>
    </div>
  )
}

export default GanadorasPage
